// Author: Daniel Castillo
// Website: https://www.prowebmerida.com
// Version 1.0.0

const config = require('./config')
const axios = require('axios')
const _ = require('underscore')


/**
* Función para enviar correo electrónico
* params
* data: parámetros requeridos para el envío de correo
*/
export async function sendMail (params) {

    if (params) {
        return axios({
            url: 'https://factura.triehotels.com/includes/sendMail.php',
            method: 'POST',
            headers: {
                'X-Parse-Application-Id': config.appId,
            },
            data: params,
        }).then((data) => {
            return data
        })
    }
}


/**
* Función que genera una contraseña aleatoria
* params
* charLength: Logitud de la contraseña
* type: solo letras, número o alphanumérico
*/
export function createPassword (charLength, type) {
    if (!charLength) charLength = 10;

    let password = '';
    let characters = '';

    switch (type) {
        case 'only-letter':
            characters  = 'abcdefghijklmnopqkrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
            break;
        case 'only-number':
            characters = '0123456789';
            break;
        case 'only-character':
            characters = 'ºª!$%&/()=?¿`+´,.-^*;:_<>[]{}–';
            break;
        case 'master':
            characters  = 'abcdefghijklmnopqkrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
            characters += '0123456789';  
            characters += 'ºª!$%&/()=?¿`+´,.-^*;:_<>[]{}–';
            break;
        default:
            characters  = 'abcdefghijklmnopqkrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
            characters += '0123456789';
    }

    for (var i = 0; i < charLength; i++) {
        var index = parseInt( Math.random() * characters.length, 10 );
        password += characters.charAt(index);
    };
    
    return password;
}


/**
* Función que devuelve la sumatoria total
* params
* array: Colección de objetos que se sumaran
* key: parámetro que se tomara en cuenta para la suma
*/
export function getTotal (array, key){

    var newArray = _.map(array, key);

    if (newArray) {
        var total = 0;
        for(var i = 0; i < newArray.length; i++){
            if (newArray[i] && _.isNumber(newArray[i])) {
                var item = newArray[i];
                total += item;
            }
        }
        return total;
    }
}


// WEBPACK FOOTER //
// ./src/utils/index.js